import React from "react";

const Support = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill"
          d="M34 21.127c0-2.398-1.55-4.4-3.705-5.189v-.952C30.295 8.386 24.77 3 18 3S5.705 8.385 5.705 14.986v.952C3.55 16.726 2 18.762 2 21.126c0 3.054 2.56 5.55 5.693 5.55h2.054a.966.966 0 00.977-.952v-9.195a.966.966 0 00-.977-.952h-.943v-.591c0-4.959 4.143-8.965 9.196-8.965s9.196 4.04 9.196 8.965v.59h-.943a.965.965 0 00-.977.953v9.195c0 .525.438.952.977.952h.438c-.977 2.2-3.133 3.744-5.693 3.94a1.44 1.44 0 00-1.415-1.116h-3.2c-.808 0-1.448.624-1.448 1.412v1.61c0 .787.64 1.411 1.448 1.411h3.2c.708 0 1.314-.492 1.415-1.182 3.806-.197 6.973-2.725 8.05-6.14C31.844 26.248 34 23.917 34 21.125z"
          fill={fill}
      />
    </svg>
);

export default Support;
